<template>
    <div class="facetedSearch facetedSearch__box hideOnDesktop facetedSearch__background">
        <!-- headline, tool tip and mobile reset button -->
        <div class="facetedSearch__mobile flex ">
            <div class="facetedSearch__head flex flex__justifyContent--spaceBetween">
                <div class="facetedSearch__headBox flex flex__alignItems--center">
                    <svg
                        class="facetedSearch__icon--32 facetedSearch__icon--right"
                        height="32"
                        width="32"
                        aria-hidden="true">
                        <use href="#iconTagDuo" />
                    </svg>
                    <!-- headline -->
                    <span class="searchCard__headline">
                        {{ trans('MOST_USED_TAGS_MOBILE') }}
                    </span>
                </div>
                <!-- reset tags button -->
                <div
                    v-if="tags.length > 0"
                    class="facetedSearch__reset flex-alignItems--center hideOnDesktop">
                    <button
                        type="button"
                        class="facetedSearch__resetText"
                        data-gtm="facetedSearch__resetAllTags"
                        @click="resetTags">
                        {{ trans('RESET') }}
                        <svg
                            class="facetedSearch__icon--16 facetedSearch__icon--left facetedSearch__resetIcon"
                            height="16"
                            width="16"
                            aria-hidden="true">
                            <use href="#iconArrowClockwiseBold" />
                        </svg>
                    </button>
                </div>
            </div>
            <span class="facetedSearch__subHeadline">
                {{ trans('IMPROVE_YOUR_SEARCH_DESC') }}
            </span>
        </div>
        <!-- selected Tags -->
        <div class="flex facetedSearch__wrapperContent">
            <div class="facetedSearch__content facetedSearch__content--selected flex">
                <button
                    v-for="tag in tags"
                    :key="tag"
                    type="button"
                    data-faceted-search
                    class="facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center"
                    :data-gtm="`facetedSearch__removeTag${ tag }`"
                    :aria-label="`Remove tag ${ tag }`"
                    @click="removeTag(tag)">
                    <span class="facetedSearch__tag--ellipsis facetedSearch__tag--ellipsisSelected">{{ tag }}</span>
                    <svg
                        class="facetedSearch__icon--16 facetedSearch__deleteIcon"
                        height="16"
                        width="16"
                        aria-hidden="true">
                        <use href="#iconCrossBold" />
                    </svg>
                </button>
            </div>
            <!-- unselected Tags -->
            <div class="facetedSearch__content flex">
                <div
                    v-for="tagsOption in tagsOptions"
                    :key="tagsOption.tag">
                    <div v-if="!tags.includes(tagsOption.tag)">
                        <button
                            type="button"
                            class="facetedSearch__tag facetedSearch__tag--ellipsis"
                            :data-gtm="`facetedSearch__tag--${ tagsOption.tag }`"
                            data-faceted-search
                            @click="addTag(tagsOption.tag)">
                            <span>{{ tagsOption.tag }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import Translator from 'tools/trans';
    export default {
        name: 'FacetedSearchMobile',
        computed: {
            ...mapGetters('search', [
                'tagsOptions',
                'masterTags',
                'tags',
            ]),
        },
        methods: {
            ...mapActions('search', [
                'resetTagsPage',
                'setTags',
                'unsetTags',
                'resetAllTags',
            ]),
            ...mapMutations('search', [
                'resetTags',
            ]),
            trans: Translator.trans,
            addTag(value) {
                this.resetTagsPage();
                this.setTags(value);
            },
            removeTag(value) {
                this.resetTagsPage();
                this.unsetTags(value);
            },
            resetTags() {
                this.resetTagsPage();
                this.resetAllTags();
            },
        },
    };
</script>
